import React from "react";
import { Navigate } from "react-router-dom";
import FeatureGuard from "./FeatureGuard";

//Dashboard
import Threatfeed from "../pages/ThreatFeed";
import PostureSummary from "../pages/PostureSummary/index.js";
import AlertsMap from "../pages/AlertsMap/index.js";
import Compliance from "../pages/Controls/index.js";
import ThreatGuard from "../pages/ThreatGuard/index.js";
import AgentControl from "../pages/AssetManagement/Agent Management/index.js";
import ComplianceShield from "../pages/ComplianceSheild/index.js";
import AssetManagement from "../pages/AssetManagement/Asset Management/index.js";
import ActiveAlerts from "../pages/ActiveAlerts/index.js";
import PatchManagement from "../pages/PatchManagement/index.js";
import VulnerabilityManagement from "../pages/Vulnerability Management/index.js";
import AntivirusDashboard from "../pages/Antivirus Dashboard/index.js";
import WebBlocking from "../pages/WebBlocking/index.js";
import SoftwareBlocking from "../pages/SoftwareBlocking/index.js";
import AgentGroups from "../pages/AgentGroups/index.js";
import AgentDashboard from "../pages/AgentThreatDetails/ThreatDetails.js";
import View from "../pages/AgentThreatDetails/View.js";

// SOAR Dashboard
import IncidentOverview from "../pages/SoarDashboard/IncidentOverview";
import IncidentSummary from "../pages/SoarDashboard/IncidentSummary";
import Analytics from "../pages/SoarDashboard/Analytics";
import IncidentsDetails from "../pages/SoarDashboard/Incidents";
import Integrations from "../pages/SoarDashboard/Integrations";
import SecurityAnalytics from "../pages/SecurityAnalytics/Index.js"
import Reports from "../pages/SecurityAnalytics/AgentThreatsReport/Index.js"
import VulnerabilityReport from "../pages/SecurityAnalytics/VulnerabilityReport/Index.js"

// Connectors
import Connectors from "../pages/Connectors/index.js";

// OT Security
import OTSecurityDashboard from "../pages/OTSecurityDashboard/index.js";

//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

// User Profile
import UserProfile from "../pages/Authentication/user-profile";

//Settings
import LogRetentionPolicy from "../pages/Settings/LogRetentionPolicy.js";
import UserActivityLogs from "../pages/Settings/UserActivityLogs.js";
import AssetForm from "../pages/AssetManagement/Asset Management/AssetForm.js";
import EditAsset from "../pages/AssetManagement/Asset Management/EditAsset.js";
//import { components } from "react-select";

const authProtectedRoutes = [
  { path: "/ThreatFeed", component: <Threatfeed /> },
  { path: "/index", component: <Threatfeed /> },
  { path: "/PostureSummary", component: <PostureSummary /> },
  { path: "/AlertsMap", component: <FeatureGuard feature="geo_location"><AlertsMap /></FeatureGuard> },
  { path: "/Compliance", component: <Compliance /> },
  { path: "/ThreatGuard", component: <ThreatGuard /> },
  { path: "/AgentControl", component: <AgentControl /> },
  { path: "/ComplianceShield", component: <ComplianceShield /> },
  { path: "/AssetManagement", component: <AssetManagement /> },
  { path: "/ActiveAlerts", component: <ActiveAlerts /> },
  { path: "/PatchManagement", component: <PatchManagement /> },
  { path: "/VulnerabilityManagement", component: <VulnerabilityManagement /> },
  { path: "/AntivirusDashboard", component: <FeatureGuard feature="av"><AntivirusDashboard /></FeatureGuard> },
  { path: "/WebBlocking", component: <FeatureGuard feature="access_control"><WebBlocking /></FeatureGuard> },
  { path: "/SoftwareBlocking", component: <FeatureGuard feature="access_control"><SoftwareBlocking /></FeatureGuard> },
  { path: "/AgentGroups", component: <FeatureGuard feature="access_control"><AgentGroups /></FeatureGuard> },
  { path: "/AgentDashboard", component: <AgentDashboard /> },
  { path: "/view-details", component: <View /> },
  { path: "/agent-report", component: <SecurityAnalytics /> },
  { path: "/agent-report/:agent", component: <Reports /> },
  { path: "/vulnerability-report", component: <VulnerabilityReport /> },
  { path: "/assets/new", component: <AssetForm /> },
  { path: "/assets/:id/edit", component: <EditAsset /> },

  // SOAR Dashboard

  { path: "/IncidentAnalytics", component: <Analytics /> },
  { path: "/IncidentOverview", component: <IncidentOverview /> },
  { path: "/IncidentManager", component: <IncidentsDetails /> },
  { path: "/IncidentSummary", component: <IncidentSummary /> },
  { path: "/Integrations", component: <Integrations /> },

  // Connectors

  { path: "/Connectors", component: <Connectors /> },

  // OT Security Dashboard
  
  { path: "/OTSecurity", component: <OTSecurityDashboard/>},

  //Settings

  { path: "/Settings/LogRetention", component: <LogRetentionPolicy /> },
  { path: "/Settings/UserActivity", component: <UserActivityLogs /> },

  //User Profile
  { path: "/profile", component: <UserProfile /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/ThreatFeed" />,
  },
  { path: "*", component: <Navigate to="/ThreatFeed" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },

];

export { authProtectedRoutes, publicRoutes };